import { useCallback } from 'react';
import { createEmptySection, ScopeSectionDraft } from './scopeEditorModel';

interface UseScopeSectionsProps {
  onSectionsChange: (sections: ScopeSectionDraft[]) => void;
  sections: ScopeSectionDraft[];
}

interface UseScopeSectionsResult {
  addSection: () => void;
  removeSection: (sectionId: string) => void;
  updateSectionRules: (sectionId: string, rules: ScopeSectionDraft['rules']) => void;
}

const useScopeSections = ({
  onSectionsChange,
  sections,
}: UseScopeSectionsProps): UseScopeSectionsResult => {
  const updateSectionRules = useCallback(
    (sectionId: string, rules: ScopeSectionDraft['rules']) => {
      onSectionsChange(
        sections.map(section => (section.id === sectionId ? { ...section, rules } : section)),
      );
    },
    [onSectionsChange, sections],
  );

  const addSection = useCallback(() => {
    onSectionsChange([...sections, createEmptySection()]);
  }, [onSectionsChange, sections]);

  const removeSection = useCallback(
    (sectionId: string) => {
      onSectionsChange(sections.filter(section => section.id !== sectionId));
    },
    [onSectionsChange, sections],
  );

  return { addSection, removeSection, updateSectionRules };
};

export default useScopeSections;
